import { render, staticRenderFns } from "./system-prompts-tab.vue?vue&type=template&id=9eeb14ca&scoped=true"
import script from "./system-prompts-tab.vue?vue&type=script&lang=js"
export * from "./system-prompts-tab.vue?vue&type=script&lang=js"
import style0 from "./system-prompts-tab.vue?vue&type=style&index=0&id=9eeb14ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eeb14ca",
  null
  
)

export default component.exports